define('views/modules/questionnaire/responses/response-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/questionnaire/response',
    'models/member/profile',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/questionnaire/responses/response-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MResponse,
    MProfile,
    // views
    VBasePanel,
    VResponseContent
) {

    var VResponsePanel = VBasePanel.extend({
        tabs: [{ id: 'results', title: 'questionnaire:Results', icon: 'sl-icon-chart', active: true }],
        content: {
            results: VResponseContent,
        },
        defaultView: 'results',

        initialize: function(opt) {
            this.options = opt = opt || {};
            var model = this.model = new MResponse(),
                results = this.getView('results', {
                    model: model,
                    questionnaire: opt.questionnaire,
                    group: opt.group,
                });

            this.listenTo(results, 'form:success', this.close)

                .listenTo(model, { 'sync': this.onModelSync });
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.model.setQuestionnaire(this.options.questionnaire);
            this.model.fetch();
            return this;
        },

        setUser: function(user) {
            this.user = user;
        },

        onModelSync: function(model) {
            var layout = this.view.layout,
                questionnaire = this.options.questionnaire;

            if (model.getComputedUser()) {
                layout.setTitle(model.getComputedUser().get('displayName'));
            } else {
                var user = new MProfile({
                    _id: this.user,
                    group: model.questionnaire.getGroup()
                });
                this.when(user.fetch()).then(function() {
                    layout.setTitle(user.get('displayName'));
                });
            }

            layout.setSubtitle(questionnaire.getTitle());
        },

    });

    return VResponsePanel;

});

